export enum Role {
  Authority = 'Authority',
  Provider = 'Provider',
  Administrator = 'Administrator',
  Organisation_administrator = 'organisation_administrator',
  Postkomponent_administrator = 'postkomponent_administrator',
  Postkomponent_supporter = 'postkomponent_supporter',
  Kombit_administrator = 'kombit_administrator',
  Kombit_supporter = 'kombit_supporter',
  Role_administrator = 'role_administrator',
  None = 'none'
}